export class PrePayment {
  srno?: number = 0;
  prePaymentId: number;
  pmsTransactionId: number;
  practiceId: number;
  patientId: number;
  prePaymentAmount: number;
  prePaymentApplied: number;
  remainingBalance: number;
  prePaymentAppliedOn: string;
  receiptId: string;
  tokenId: number;
  lastFourDigits: string;
  cardType: string;
  accountNumber: string;
  createDate: string;
  createdBy: string;
  transactionType: number;
  checkNumber: string;
  id: string;
  description?: string = '';
}

export class ApplyPrePayment {
  prePaymentId: number;
  practiceId: number;
  patientId: number;
  amountToApply: number;
  providerId?: number = 0;
  note?: string = '';
  patientName?:string='';
  ownerType?:number;
}

export class PrePaymentListResp {
  prePaymentItems: PrePayment[] = [];
  totalPrePayment: number = 0;
  totalRecords: number;
}
